import { Card, Divider, Row, Col } from 'antd'
import { FC } from 'react'
import '../styles/CharacteristicCard.scss'

interface CharacteristicCardProps {
	title: string
	data: {
		label: string
		value: string | number
	}[]
	icon?: React.ReactNode
}

export const CharacteristicCard: FC<CharacteristicCardProps> = ({
	title,
	data,
	icon
}) => {
	return (
		<Card className="characteristic-card">
			<div className="characteristic-header">
				{icon && (
					<span className="characteristic-icon">
						{icon}
					</span>
				)}
				<h3 className="characteristic-title">{title}</h3>
			</div>
			<Divider style={{ margin: '12px 0' }} />
			<div className="characteristic-content">
				<Row gutter={[16, 16]}>
					{data.map((item, index) => (
						<Col xs={24} sm={12} md={8} key={index}>
							<div className="characteristic-item">
								<span className="characteristic-label">
									{item.label}
								</span>
								<span className="characteristic-value">
									{item.value}
								</span>
							</div>
						</Col>
					))}
				</Row>
			</div>
		</Card>
	)
}
